import { g as o } from "./_commonjsHelpers-B52_cu2H.js";
import { r } from "./memoize-DWwe-irS.js";
var e = r();
const i = /* @__PURE__ */ o(e);
export {
  i as m
};
